import { ReactElement } from 'react';
import * as React from 'react';
import dynamic from 'next/dynamic';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Header } from '@zoopla/header';
import { Footer } from '@zoopla/footer';
import { Banner } from '@zoopla/layout/consent';
import { AdScripts } from '@zoopla/adverts/dfp';
import { useRouter } from 'next/router';

const StyledHeader = styled('header')(
    (props) => css`
        @media only screen and (min-width: ${props.theme.breakpoints[2]}px) {
            position: relative;
            box-shadow: ${props.theme.boxShadow['100']};
            z-index: 100;
        }
    `
);
const GoogleOneTap = dynamic<Record<string, unknown>>(
    () =>
        import('@zoopla/authentication/modal').then(
            (module) => module.GoogleOneTap
        ),
    {
        ssr: false
    }
);

/**
 * Default layout used across site, includes web chrome i.e header, footer etc
 */
export const Layout: React.FC = ({ children }) => {
    const { asPath } = useRouter();

    return (
        <>
            <AdScripts />
            <Banner />
            <StyledHeader>
                <Header path={asPath} />
            </StyledHeader>
            {children}
            <GoogleOneTap />
            <Footer />
        </>
    );
};

/**
 * Default getLayout function used if not defined on the Page component.
 * @see {Layout}
 */
export const getWebChromeLayout = (page: ReactElement): ReactElement => (
    <Layout>{page}</Layout>
);
